import React, { Component, PropTypes } from 'react';
import pick from 'lodash/pick';
import MessageTimeline from 'common/containers/message_timeline';

/**
 * Updates brief section.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class Updates extends Component {
  componentDidMount() {
    const { fetchMessagesIfNeeded, project } = this.props;

    if (project.message_stream_id) {
      fetchMessagesIfNeeded({ streamId: project.message_stream_id, project });
    }
  }

  render() {
    const timelineProps = pick(
      this.props,
      ['canPost', 'canAttach', 'editorLabel', 'editorActionLabel', 'startAt', 'emptyLabel',
       'project', 'canPostInternal']
    );

    return (
      <section className="row brief-section">
        <div className="small-16 large-4 columns brief-title">
          <h2>Updates</h2>
        </div>

        <div className="small-16 large-9 columns brief-content">
          <MessageTimeline {...timelineProps} />
        </div>
      </section>
    );
  }
}

/**
 * PropTypes.
 *
 * @property {func} fetchMessagesIfNeeded - fetch project messages if not already
 * @property {object} project - current project
 * @property {bool} canPost - whether logged in user can post messages
 * @property {bool} canAttach - whether logged in user can add attachments to messages
 * @property {string} emptyLabel - custom empty timeline label
 * @property {string|node} editorLabel - custom label for main editor
 * @property {string} editorActionLabel - custom action button label for main editor
 * @property {string} startAt - show updates starting at specified timestamp
 */
Updates.propTypes = {
  fetchMessagesIfNeeded: PropTypes.func,
  project: PropTypes.object,
  canPost: PropTypes.bool,
  canAttach: PropTypes.bool,
  editorLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  emptyLabel: PropTypes.string,
  editorActionLabel: PropTypes.string,
  startAt: PropTypes.string,
};



// WEBPACK FOOTER //
// ./project/components/brief/updates.jsx